export default {
    delete: {
        success: 'Trend radar successfully deleted',
        error: 'Error when deleting the trend radar'
    },
    copy: {
        success: 'Trend radar successfully copied',
        error: 'Error when copying the trend radar'
    },
    create: {
        success: 'Trend radar successfully created',
        error: 'Error when creating the trend radar'
    },
    update: {
        success: 'Trend radar successfully updated',
        error: 'Error when updating the trend radar'
    },
    publish: {
        success: 'Trend radar successfully published',
        error: 'Error when publishing the trend radar'
    },
    unpublish: {
        success: 'Trend radar successfully unpublished',
        error: 'Error when unpublishing the trend radar'
    },
    setSharingOptions: {
        success: 'Trend radar sharing options successfully updated',
        error: 'Error when updating the options for sharing the trend radar'
    },
    setSharingOptionsLogo: {
        success: 'Logo for the public view of the Trend Radar successfully updated',
        error: 'Error updating the logo for the public trend radar view'
    },
    deleteSharingOptionsLogo: {
        success: 'Logo for the public view of the trend radar successfully deleted',
        error: 'Error when deleting the logo for the public trend radar view'
    },
    setEvaluationEnabled: {
        success: {
            enabled: 'Ratings for this trend radar unlocked',
            disabled: 'Ratings for this trend radar locked'
        },
        error: {
            enabled: 'Error when activating the ratings for this trend radar',
            disabled: 'Error when deactivating the ratings for this trend radar'
        }
    },
    createPanel: {
        success: 'Trend radar panel was successfully created',
        error: 'Error when creating a trend radar panel'
    },
    overrideEvaluation: {
        success: 'The override was successfully updated',
        error: 'Error when updating the override'
    },
    deleteOverride: {
        success: 'The override was successfully deleted',
        error: 'Error when deleting the override'
    },
    setPerception: {
        success: 'Assessment was successfully updated',
        error: 'Error when updating the assessment'
    },
    republish: {
        success: 'Published trend radar was successfully updated',
        error: 'Error when updating the published trend radar'
    }
}
